module.exports = __webpack_public_path__ + "static/media/paff-song-mask.df9af91c.png";